export class EntityModel {
  id: number = null;
}
